import React from 'react';
import { Link } from 'react-router-dom';
import sty from './ErrorPage.module.css';

// (仮)社外向け
const InternalServerError = () => {
    return (
        <div className={sty['error__contents-outer']}>
            <div className={sty['error__tit-outer']}>
                <h1 className={sty['error__page-tit']}>500 Internal Server Error</h1>
                <p className={sty['error__contents-txt']}>申し訳ありません。サーバーでエラーが発生しました</p>
            </div>
        </div>
    );
};

export default InternalServerError;